/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var EmailTemplate;
(function (EmailTemplate) {
    EmailTemplate["STORE_AVAILABILITY_STATUS"] = "store-availability-status";
    EmailTemplate["CHARGEBACK_SUMMARY"] = "chargeback-summary";
    EmailTemplate["SHIFT_REPORT"] = "shift_report";
    EmailTemplate["POPCHEW_STORE_PERFORMANCE_REPORT"] = "popchew_store_performance_report";
    EmailTemplate["ACCOUNTING_PUSH_COMPLETED"] = "accounting_push_completed";
    EmailTemplate["ACCOUNTING_PUSH_NOTIFY"] = "accounting_push_notify";
    EmailTemplate["ACCOUNTING_PUSH_NOTIFY_PAUSED"] = "accounting_push_notify_paused";
    EmailTemplate["ACCOUNTING_FREETEXT_JOURNAL"] = "accounting_freetext_journal";
    EmailTemplate["UNMAPPED_GL_ACCOUNTING_COMPANIES"] = "unmapped_gl_accounting_companies";
    EmailTemplate["ACCOUNTING_ACCESS_LOST"] = "accounting_access_lost";
    EmailTemplate["DIGITAL_STORES_ACCESS_LOST"] = "digital_stores_access_lost";
    EmailTemplate["UNMAPPED_STORES"] = "unmapped_stores";
    EmailTemplate["REVIEW_SUMMARY_REPORT"] = "review_summary_report";
    EmailTemplate["ISSUE_DISSCOVERY"] = "issue-disscovery";
    EmailTemplate["ISSUE_DISCOVERY_ALERT"] = "issue_discovery_alert";
    EmailTemplate["PLAID_ACCESS_LOST"] = "plaid_access_lost";
    EmailTemplate["STORE_AVAILABILITY_DIGEST"] = "store_availability_digest";
    EmailTemplate["STORE_AVAILABILITY_REALTIME"] = "store_availability_realtime";
    EmailTemplate["DISPUTES_OPT_OUT"] = "disputes_opt_out";
    EmailTemplate["GUARD_SUMMARY"] = "guard_summary";
    EmailTemplate["WELCOME_INVITED_USER"] = "welcome-invited-user";
    EmailTemplate["WELCOME_LOOP_NEW"] = "WELCOME_LOOP_NEW";
    EmailTemplate["MAGIC_LINK"] = "magic_link";
    EmailTemplate["PASSWORD_OTP"] = "password_otp";
    EmailTemplate["RESET_PASSWORD"] = "reset-password";
    EmailTemplate["VERIFY_EMAIL"] = "verify-email";
    EmailTemplate["REPORT_READY_EMAIL"] = "report_ready_email";
    EmailTemplate["SMS_TO_SUPPORT"] = "sms_to_support";
})(EmailTemplate || (EmailTemplate = {}));
